import { Collection } from 'modules/core/lib/mobx-rest'

import ChargebeeSubscription from 'modules/billing/store/models/ChargebeeSubscription'

class ChargebeeSubscriptions extends Collection<ChargebeeSubscription> {
  get cacheKey(): string {
    return 'chargebeeSubscriptions'
  }

  model() {
    return ChargebeeSubscription
  }
}

const singleton: ChargebeeSubscriptions = new ChargebeeSubscriptions()

export default singleton
